import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class PayrollCalculationScenarioData  {
    _originalTypeClassName = "zERP.BO.PayrollCalculationScenarioData";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
PayrollCalculationScenarioData.translate = translateService;
}
this.ParamOne = null;
this.ParamTwo = null;
this.ParamThree = null;
this.PayrollCalculationScenarioDataKey = null;
this._key = this.PayrollCalculationScenarioDataKey = 0; 
}

static translate: TranslateService;
_key: any;
ParamOne:any;
ParamTwo:any;
ParamThree:any;
private _PayrollCalculationScenarioDataKey:any;
get PayrollCalculationScenarioDataKey(): any {
    return this._PayrollCalculationScenarioDataKey;
  }
set PayrollCalculationScenarioDataKey(value: any) {
    this._PayrollCalculationScenarioDataKey = value;
    this._key = value;
  }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.PayrollCalculationScenarioDataKey == null || $this.PayrollCalculationScenarioDataKey == 0;
            }


}